import React from "react";
import { useState } from "react";
import { Paginator } from "primereact/paginator";
import { useEffect } from "react";
import { useMediaQuery } from "react-responsive";

const TitleAndPagination = (props) => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const [totalRecords, setTotalRecords] = useState(props.totalRecords);
  const [limit, setLimit] = useState(props.limit);
  const [first, setFirst] = useState(0);

  useEffect(() => {
    setTotalRecords(props.totalRecords);
    setLimit(props.limit);
  }, [props.totalRecords, props.limit]);

  const handleLimitClick = (e) => {
    props.handleLimit(e);
    setLimit(e);
  };

  const onPageChange = (event) => {
    props.handlePageChange(event.page);
    setFirst(event.first);
    setLimit(event.rows);
  };

  return (
    <div>
      {isMobile && (
        <div>
          <div className="title-and-pagination" style={{ display: "flex" }}>
            <h1>
              {" "}
              {props.title}{" "}
              <span style={{ color: "#0944C2" }}>
                ({props.totalRecords ?? 0})
              </span>{" "}
            </h1>

            <div className="display-number">
              <span>No. of display</span>
              <button
                className={`${limit === 20 ? "selected" : "unselected"}`}
                onClick={() => handleLimitClick(20)}
              >
                20
              </button>
              <button
                className={`${limit === 50 ? "selected" : "unselected"}`}
                onClick={() => handleLimitClick(50)}
              >
                50
              </button>
              <button
                className={`${limit === 100 ? "selected" : "unselected"}`}
                onClick={() => handleLimitClick(100)}
              >
                100
              </button>
            </div>
          </div>
          <div style={{ paddingTop: 25 }}>
            <Paginator
              first={first}
              rows={limit}
              totalRecords={totalRecords}
              onPageChange={onPageChange}
            />
          </div>
        </div>
      )}
      {!isMobile && (
        <div>
          <div className="title-and-pagination" style={{ display: "flex" }}>
            <h1>
              {props.title}{" "}
              <span style={{ color: "#0944C2" }}>
                ({props.totalRecords ?? 0})
              </span>
            </h1>

            <div className="display-number">
              <span>No. of display</span>
              <button
                className={`${limit === 20 ? "selected" : "unselected"}`}
                onClick={() => handleLimitClick(20)}
              >
                20
              </button>
              <button
                className={`${limit === 50 ? "selected" : "unselected"}`}
                onClick={() => handleLimitClick(50)}
              >
                50
              </button>
              <button
                className={`${limit === 100 ? "selected" : "unselected"}`}
                onClick={() => handleLimitClick(100)}
              >
                100
              </button>
            </div>
            <Paginator
              first={first}
              rows={limit}
              totalRecords={totalRecords}
              onPageChange={onPageChange}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export const Pagination = ({ style }) => (
  <div className="display-number" style={style ? style : {}}>
    <i className="fa fa-angle-left"></i>
    <button>1</button>
    <button>2</button>
    <button>3</button>
    <button className="m20">68</button>
    <i className="fa fa-angle-right"></i>
  </div>
);

export default TitleAndPagination;
